export const entities = {
    BROKERS: "brokers",
    COWORKERS: "coworkers",
    PARTNERS: "partners",
    OFFERTS: "offerts",
    NOTES: "notes",
};